(function(){
  if(window.KVOEMExperience){window.KVOEMExperience.init(document);return;}

  function initTabs(root){
    if(root.dataset.kvTabsReady==='true') return;
    root.dataset.kvTabsReady='true';
    const tabs=[...root.querySelectorAll('[data-kv-tab]')];
    const panels=[...root.querySelectorAll('[data-kv-panel]')];
    if(!tabs.length||!panels.length) return;
    function activate(tab,focus){
      const id=tab.getAttribute('aria-controls');
      tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',active?'true':'false');t.tabIndex=active?0:-1;});
      panels.forEach(p=>{p.hidden=p.id!==id;});
      if(focus) tab.focus();
    }
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>activate(tab,false));
      tab.addEventListener('keydown',e=>{
        if(!['ArrowRight','ArrowDown','ArrowLeft','ArrowUp','Home','End'].includes(e.key)) return;
        e.preventDefault(); let next=index;
        if(e.key==='ArrowRight'||e.key==='ArrowDown') next=(index+1)%tabs.length;
        if(e.key==='ArrowLeft'||e.key==='ArrowUp') next=(index-1+tabs.length)%tabs.length;
        if(e.key==='Home') next=0; if(e.key==='End') next=tabs.length-1;
        activate(tabs[next],true);
      });
    });
    activate(tabs.find(t=>t.getAttribute('aria-selected')==='true')||tabs[0],false);
  }

  function initGallery(root){
    if(root.dataset.kvGalleryReady==='true') return;
    root.dataset.kvGalleryReady='true';
    if(root.dataset.layout!=='carousel') return;
    const track=root.querySelector('[data-kv-gallery-track]');
    const prev=root.querySelector('[data-kv-gallery-prev]');
    const next=root.querySelector('[data-kv-gallery-next]');
    if(!track) return;
    function step(){const item=track.querySelector('.kv-oem-media-gallery__item');return item?item.getBoundingClientRect().width+18:Math.max(280,track.clientWidth*.72);}
    function move(dir){track.scrollBy({left:dir*step(),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
    if(prev)prev.addEventListener('click',()=>move(-1));
    if(next)next.addEventListener('click',()=>move(1));
  }

  function initSelector(root){
    if(root.dataset.kvSelectorReady==='true') return;
    root.dataset.kvSelectorReady='true';
    const modal=root.querySelector('[data-kv-selector-modal]');
    const form=root.querySelector('[data-kv-selector-form]');
    const openButtons=[...root.querySelectorAll('[data-kv-selector-open]')];
    if(!modal||!form||!openButtons.length) return;
    const closeEls=[...modal.querySelectorAll('[data-kv-selector-close]')];
    const steps=[...form.querySelectorAll('[data-kv-selector-step]')];
    const result=form.querySelector('[data-kv-selector-result]');
    const progress=modal.querySelector('[data-kv-selector-progress]');
    const progressText=modal.querySelector('[data-kv-selector-progress-text]');
    const applicationChoices=[...form.querySelectorAll('[data-kv-application-choices] [data-market]')];
    let index=0,lastFocus=null,lastSpecText='',shareTimer=null,shareObserver=null,shareMode='specialist';
    let focusWhenReady=false,scrollYBeforeOpen=0,savedBodyStyle=null,inertElements=[];
    const copyNode=root.querySelector('[data-kv-copy-settings]');
    let copySettings={};
    try{copySettings=JSON.parse(copyNode?.textContent||'{}');}catch(e){console.warn('KV OEM: invalid copy settings',e);}
    function parseCopy(key){try{return JSON.parse(copySettings[key]||'{}');}catch(e){return {};}}
    const resultMessages=Object.assign({},parseCopy('result_messages'),parseCopy('result_messages_2'));
    function T(message){return Object.prototype.hasOwnProperty.call(resultMessages,message)?String(resultMessages[message]):message;}

    const sharePanel=root.querySelector('[data-kv-share-panel]');

    function marketInput(){return form.querySelector('[name="market"]:checked')||form.querySelector('input[name="market"][type="hidden"]');}
    function currentMarket(){const i=marketInput();return i?i.value:'other';}
    function filterApplications(){
      const market=currentMarket();
      applicationChoices.forEach(choice=>{
        const show=choice.dataset.market===market;
        choice.hidden=!show;
        const input=choice.querySelector('input');
        if(input){input.disabled=!show;if(!show)input.checked=false;}
      });
    }

    // Dialog remains a descendant of its Shopify section so editor styles/app blocks stay intact.
    function showModal(){
      if(!modal.hidden)return;
      lastFocus=document.activeElement;
      modal.hidden=false;
      scrollYBeforeOpen=window.scrollY;
      savedBodyStyle={position:document.body.style.position,top:document.body.style.top,width:document.body.style.width,overflow:document.body.style.overflow};
      document.body.classList.add('kv-oem-modal-open');
      document.body.style.position='fixed';document.body.style.top=-scrollYBeforeOpen+'px';document.body.style.width='100%';
      // Make only siblings of the ancestor chain inert; never inert the dialog itself.
      inertElements=[];let branch=modal;
      while(branch.parentElement&&branch.parentElement!==document.documentElement){
        [...branch.parentElement.children].forEach(el=>{if(el!==branch&&el instanceof HTMLElement&&!el.inert){el.inert=true;inertElements.push(el);}});
        branch=branch.parentElement;
      }
      filterApplications();
      if(!lastSpecText)showStep(false);
      else if(sharePanel&&!sharePanel.hidden)watchHulk();
      updateViewport();
      modal.querySelector('.kv-oem-selector__close')?.focus({preventScroll:true});
    }
    function hideModal(){
      if(modal.hidden)return;
      modal.hidden=true;stopHulkWatch();document.body.classList.remove('kv-oem-modal-open');
      inertElements.forEach(el=>el.inert=false);inertElements=[];
      if(savedBodyStyle)Object.assign(document.body.style,savedBodyStyle);
      window.scrollTo(0,scrollYBeforeOpen);
      if(lastFocus?.isConnected)lastFocus.focus({preventScroll:true});
    }
    function updateViewport(){
      if(modal.hidden)return;
      const vp=window.visualViewport;
      modal.style.setProperty('--kv-viewport-height',(vp?vp.height:window.innerHeight)+'px');
      modal.style.setProperty('--kv-viewport-top',(vp?vp.offsetTop:0)+'px');
    }
    window.visualViewport?.addEventListener('resize',updateViewport);
    window.visualViewport?.addEventListener('scroll',updateViewport);
    function setNativeValue(el,val){
      if(!el||el.value===val)return;
      const proto=el.tagName==='TEXTAREA'?HTMLTextAreaElement.prototype:HTMLInputElement.prototype;
      const setter=Object.getOwnPropertyDescriptor(proto,'value')?.set;
      if(setter)setter.call(el,val);else el.value=val;
      el.dispatchEvent(new Event('input',{bubbles:true}));el.dispatchEvent(new Event('change',{bubbles:true}));
    }
    function fieldName(el){
      const names=[el.name,el.id,el.placeholder,el.getAttribute('aria-label'),el.getAttribute('data-field-name'),el.getAttribute('data-label'),...[...el.labels||[]].map(l=>l.textContent)];
      (el.getAttribute('aria-labelledby')||'').split(/\s+/).filter(Boolean).forEach(id=>{
        const label=el.ownerDocument.getElementById(id);if(label)names.push(label.textContent);
      });
      // Some app layouts use a visible sibling label without a native label/for link.
      // Read only a local wrapper containing this one non-hidden form control.
      let wrapper=el.parentElement;
      for(let depth=0;wrapper&&depth<4;depth++,wrapper=wrapper.parentElement){
        if(wrapper.matches('form,[data-kv-hulk-container]'))break;
        const controls=wrapper.querySelectorAll('textarea,input:not([type="hidden"]),select');
        if(controls.length>1)break;
        if(controls.length===1&&controls[0]===el){
          const labels=[...wrapper.querySelectorAll('label,[data-field-label],.field-label,.form-label')];
          labels.forEach(l=>names.push(l.textContent));
          if(labels.length)break;
        }
      }
      return names.filter(Boolean).join(' ').replace(/[_\-]+/g,' ').replace(/\s+/g,' ').trim();
    }
    let hulkIssue='missing';
    function findHulkField(){
      hulkIssue='missing';
      const host=sharePanel?.querySelector('[data-kv-hulk-container]');
      if(!host)return null;
      const eligible=el=>!!el&&!el.disabled&&!el.hasAttribute('data-kv-copy-text')&&/^(TEXTAREA|INPUT)$/.test(el.tagName);
      const visible=el=>el.getClientRects().length>0&&getComputedStyle(el).visibility!=='hidden'&&!el.closest('[hidden]');
      const configured=(root.dataset.hulkResultSelector||'').trim();
      if(configured){try{
        const found=[...host.querySelectorAll(configured)].filter(eligible);
        if(found.length===1)return found[0];
        if(found.length>1){hulkIssue='ambiguous';return null;}
      }catch(e){/* Ignore an invalid optional selector; use the existing form's labels. */}}
      const controls=[...host.querySelectorAll('textarea,input[type="text"],input[type="hidden"],input:not([type])')].filter(eligible);
      const groups=[
        controls.filter(el=>/oem project specifications?|project specifications?|configurator results/i.test(fieldName(el))),
        controls.filter(el=>el.tagName==='TEXTAREA'&&/additional project details/i.test(fieldName(el))),
        controls.filter(el=>el.tagName==='TEXTAREA'&&lastSpecText&&String(el.value).includes(lastSpecText))
      ];
      for(const matches of groups){
        const shown=matches.filter(visible);
        if(shown.length===1)return shown[0];
        if(matches.length===1)return matches[0];
        if(matches.length>1){hulkIssue='ambiguous';return null;}
      }
      // This dedicated OEM form has one editable paragraph. Never select the copy
      // box, another page form, a read-only control, or an arbitrary text input.
      const paragraphs=controls.filter(el=>el.tagName==='TEXTAREA'&&!el.readOnly&&visible(el));
      if(paragraphs.length===1)return paragraphs[0];
      if(paragraphs.length>1)hulkIssue='ambiguous';
      return null;
    }
    function hulkFailureMessage(){
      if(hulkIssue==='length')return T('The form field is too short for these specifications. Copy your results and contact KV; the form needs a larger character limit.');
      if(hulkIssue==='ambiguous')return T('More than one project details field was found. Use Copy Results and paste the specifications into Additional Project Details before submitting.');
      if(hulkIssue==='write')return T('The form has not retained the complete specifications. Use Copy Results and paste it into Additional Project Details before submitting.');
      return T('Automatic transfer is not ready. Use Copy Results and paste the specifications into Additional Project Details before submitting.');
    }
    const SPEC_START='[KV OEM CONFIGURATOR SPECIFICATION]';
    const SPEC_END='[/KV OEM CONFIGURATOR SPECIFICATION]';
    function resultValue(field){
      if(/oem project specifications?|project specifications?|configurator results/i.test(fieldName(field)))return lastSpecText;
      const current=String(field.value||'');
      const start=current.indexOf(SPEC_START),end=current.indexOf(SPEC_END,start);
      const block=SPEC_START+'\n'+lastSpecText+'\n'+SPEC_END;
      if(start>=0&&end>=start)return current.slice(0,start)+block+current.slice(end+SPEC_END.length);
      if(current.includes(lastSpecText))return current;
      return block+'\n\n'+(current.trim()?current:T('Additional project comments:')+'\n');
    }
    function setHulkStatus(ok,message){
      if(!sharePanel)return;
      const status=sharePanel.querySelector('[data-kv-hulk-status]');
      if(status){status.textContent=message;status.dataset.status=ok?'ready':'waiting';}
    }
    function populateHulk(){
      if(!sharePanel||!lastSpecText)return false;
      const field=findHulkField();
      if(!field)return false;
      const next=resultValue(field);
      if(field.maxLength>=0&&next.length>field.maxLength){
        hulkIssue='length';
        setHulkStatus(false,T('The form field is too short for these specifications. Copy your results and contact KV; the form needs a larger character limit.'));
        return false;
      }
      try{setNativeValue(field,next);}catch(e){hulkIssue='write';return false;}
      const ok=field.value.includes(lastSpecText);
      hulkIssue=ok?'ready':'write';
      if(ok)setHulkStatus(true,T('Your project specifications are included in Additional Project Details. Add any comments below the specifications.'));
      if(ok&&focusWhenReady){
        focusWhenReady=false;
        let target=null;
        if(shareMode==='email'){
          try{target=sharePanel.querySelector(root.dataset.hulkEmailSelector||'input[type="email"]');}catch(e){}
        }
        target=target||sharePanel.querySelector('input:not([type="hidden"]):not([disabled]),textarea:not([disabled])');
        // Do not steal focus if the visitor already started entering information.
        if(target&&!(sharePanel.contains(document.activeElement)&&/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)))target.focus({preventScroll:true});
      }
      return ok;
    }
    function stopHulkWatch(){clearTimeout(shareTimer);shareTimer=null;if(shareObserver){shareObserver.disconnect();shareObserver=null;}}
    function watchHulk(){
      stopHulkWatch();let attempts=0;
      const tick=()=>{
        if(!sharePanel||sharePanel.hidden||modal.hidden)return;
        if(populateHulk())return;
        if(hulkIssue!=='missing')setHulkStatus(false,hulkFailureMessage());
        if(++attempts<80)shareTimer=setTimeout(tick,500);
        else setHulkStatus(false,hulkFailureMessage());
      };
      shareObserver=new MutationObserver(()=>{if(!sharePanel.hidden)populateHulk();});
      shareObserver.observe(sharePanel.querySelector('[data-kv-hulk-container]')||sharePanel,{childList:true,subtree:true,attributes:true,attributeFilter:['id','name','placeholder','aria-label','aria-labelledby','disabled','readonly','maxlength']});
      tick();
    }
    function openShare(mode){
      if(!sharePanel||!lastSpecText)return;
      shareMode=mode;focusWhenReady=true;
      const heading=sharePanel.querySelector('[data-kv-share-heading]');
      const copy=sharePanel.querySelector('[data-kv-share-copy]');
      if(heading)heading.textContent=mode==='email'?root.dataset.emailTitle:root.dataset.shareTitle;
      if(copy)copy.textContent=mode==='email'?root.dataset.emailCopy:root.dataset.shareCopy;
      sharePanel.hidden=false;
      setHulkStatus(false,T('Preparing your specifications for the form…'));
      sharePanel.querySelector('[data-kv-copy-text]').value=lastSpecText;
      watchHulk();
      sharePanel.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    // Never inject a made-up submission field: only an existing Hulk-defined field is used.
    if(sharePanel){
      const guard=e=>{
        if(!lastSpecText||sharePanel.hidden)return;
        if(e.type==='click'&&!e.target.closest('button[type="submit"],input[type="submit"],form button:not([type])'))return;
        if(!populateHulk()){
          e.preventDefault();e.stopImmediatePropagation();
          setHulkStatus(false,hulkFailureMessage());
        }
      };
      sharePanel.addEventListener('submit',guard,true);sharePanel.addEventListener('click',guard,true);
      sharePanel.querySelector('[data-kv-copy-button]')?.addEventListener('click',async()=>{
        try{await navigator.clipboard.writeText(lastSpecText);sharePanel.querySelector('[data-kv-copy-feedback]').textContent=T('Results copied.');}
        catch(e){const area=sharePanel.querySelector('[data-kv-copy-text]');area.closest('details').open=true;area.focus();area.select();sharePanel.querySelector('[data-kv-copy-feedback]').textContent=T('Select and copy the text below.');}
      });
    }
    function printResults(){
      if(!lastSpecText||!result)return;
      document.getElementById('kv-oem-print-root')?.remove();
      const printRoot=document.createElement('article');printRoot.id='kv-oem-print-root';
      const title=document.createElement('p');title.className='kv-oem-print-brand';title.textContent='Knape & Vogt';printRoot.appendChild(title);
      const clone=result.cloneNode(true);clone.hidden=false;
      clone.querySelectorAll('.kv-oem-selector__engineering-review,button,a,.kv-oem-selector__restart-link,script,input,textarea').forEach(n=>n.remove());
      clone.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));
      clone.querySelectorAll('[hidden]').forEach(n=>n.remove());
      printRoot.appendChild(clone);
      document.body.appendChild(printRoot);
      document.body.classList.add('kv-oem-printing');
      const cleanup=()=>{document.body.classList.remove('kv-oem-printing');printRoot.remove();window.removeEventListener('afterprint',cleanup);};
      window.addEventListener('afterprint',cleanup,{once:true});
      // Defer until the print-only DOM has a layout; no new windows/pop-up permissions required.
      requestAnimationFrame(()=>requestAnimationFrame(()=>{try{window.print();}catch(e){cleanup();console.error('KV OEM print failed',e);}}));
    }
    modal.querySelectorAll('[data-kv-share-open]').forEach(b=>b.addEventListener('click',()=>openShare(b.dataset.kvShareOpen||'specialist')));
    modal.querySelectorAll('[data-kv-share-close]').forEach(b=>b.addEventListener('click',()=>{sharePanel.hidden=true;stopHulkWatch();modal.querySelector('[data-kv-share-open]')?.focus();}));
    modal.querySelectorAll('[data-kv-print]').forEach(b=>b.addEventListener('click',printResults));
    openButtons.forEach(b=>b.addEventListener('click',showModal));
    closeEls.forEach(el=>el.addEventListener('click',hideModal));
    modal.addEventListener('keydown',e=>{
      if(e.key==='Escape'){e.preventDefault();hideModal();return;}
      if(e.key==='Tab'){
        const controls=[...modal.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')].filter(el=>!el.disabled&&el.tabIndex>=0&&el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden');
        if(!controls.length){e.preventDefault();return;}
        const first=controls[0],last=controls[controls.length-1];
        if(e.shiftKey&&(document.activeElement===first||!controls.includes(document.activeElement))){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&(document.activeElement===last||!controls.includes(document.activeElement))){e.preventDefault();first.focus();}
      }
    });
    form.addEventListener('submit',e=>e.preventDefault());
    form.querySelectorAll('[name="market"]').forEach(i=>i.addEventListener('change',filterApplications));
    root.kvOemCleanup=()=>{hideModal();stopHulkWatch();window.visualViewport?.removeEventListener('resize',updateViewport);window.visualViewport?.removeEventListener('scroll',updateViewport);};

    function showStep(focus=true){
      if(sharePanel)sharePanel.hidden=true;stopHulkWatch();
      steps.forEach((s,i)=>s.hidden=i!==index);
      if(result) result.hidden=true;
      if(steps[index]&&steps[index].querySelector('[data-kv-application-choices]')) filterApplications();
      const total=steps.length,pct=total?((index+1)/total)*100:100;
      if(progress)progress.style.width=pct+'%';
      if(progressText)progressText.textContent=T('Step {current} of {total}').replace('{current}',index+1).replace('{total}',total);
      const activeNext=steps[index]?.querySelector('[data-kv-selector-next]');
      if(activeNext){
        const explicit=(activeNext.dataset.kvNextLabel||'').trim();
        activeNext.textContent=index===total-1?(root.dataset.buildLabel||'Generate Project Specifications'):(explicit||root.dataset.nextLabel||'Continue');
      }
      const legend=steps[index]?.querySelector('legend');if(focus&&legend){legend.tabIndex=-1;legend.focus({preventScroll:true});modal.querySelector('.kv-oem-selector__dialog').scrollTop=0;}
    }
    function currentStep(){return steps[index];}
    function validate(){
      const step=currentStep();if(!step)return true;
      const group=step.dataset.requiredGroup,err=step.querySelector('[data-kv-selector-error]');
      if(group&&!form.querySelector('[name="'+group+'"]:checked')){if(err)err.textContent=T('Please choose an option to continue.');return false;}
      if(err)err.textContent='';return true;
    }
    form.querySelectorAll('[data-kv-selector-next]').forEach(b=>b.addEventListener('click',()=>{if(!validate())return;if(index<steps.length-1){index++;showStep();}else buildResult();}));
    form.querySelectorAll('[data-kv-selector-back]').forEach(b=>b.addEventListener('click',()=>{if(index>0){index--;showStep();}}));
    form.querySelectorAll('[data-kv-selector-restart]').forEach(b=>b.addEventListener('click',()=>{form.reset();lastSpecText='';if(sharePanel)sharePanel.hidden=true;stopHulkWatch();index=0;filterApplications();showStep();}));

    function checked(name){return [...form.querySelectorAll('[name="'+name+'"]:checked')];}
    function label(input){return input?input.dataset.label||input.closest('label')?.querySelector('strong')?.textContent?.trim()||input.value:'';}
    function value(name){return form.elements[name]?.value?.trim?.()||'';}
    function esc(str){return String(str||'').replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));}
    function addUnique(arr,text){if(text&&!arr.includes(text))arr.push(text);}
    function joinLabels(inputs,fallback){return inputs.length?inputs.map(label).filter(Boolean).join(', '):(fallback||'Not specified');}

    const marketNotes={
      automotive:'Review packaging, attachment, retention, vibration / shock, corrosion exposure, and vehicle-level use conditions together.',
      server:'Review rack and chassis integration, service access, load / deflection, cable routing, retention, and repeated service together.',
      appliance:'Review operating feel, closing behavior, appliance volume, moisture / corrosion, temperature, and cycle requirements together.',
      healthcare:'Review frequent use, operating force, controlled access, serviceability, compact packaging, and the equipment environment together.',
      office:'Review operating feel, cycle life, security, stability, packaging, and furniture manufacturing integration together.',
      tool:'Review load, drawer geometry, extension, locking / retention, mobile vibration, structural support, and cycle requirements together.',
      other:'Review the finished application, load, travel, mounting, operating environment, duty cycle, and user interaction before part selection.'
    };
    Object.assign(marketNotes,parseCopy('marketNotes'));
    const marketValidation={
      automotive:'Validate retention, vibration / shock response, end-stop behavior and mounting in a representative vehicle-level configuration.',
      server:'Validate loaded chassis deflection, full-service access, disconnect / retention and repeated service cycles in the intended rack design.',
      appliance:'Validate operating force, closing behavior, corrosion / moisture exposure, temperature and repeated appliance-use cycles.',
      healthcare:'Validate repeated-use durability, operating force, controlled access, serviceability and the intended equipment environment.',
      office:'Validate cycle life, operating feel, stability, locking / retention and full-access behavior in the finished furniture assembly.',
      tool:'Validate structural load, drawer deflection, end-stop / impact behavior, locking / retention and repeated heavy-duty cycles.',
      other:'Validate the mechanism in the representative finished-product configuration whenever geometry, mounting, structure or environment materially affects performance.'
    };
    Object.assign(marketValidation,parseCopy('marketValidation'));

    const loadMap={
      under75:'Load capacity appropriate to the lighter-duty end of the application range.',
      up150:'Load capacity and structural support sized for a moderate-load application.',
      up250:'Higher-load capacity with drawer / chassis structure and mounting reviewed together.',
      up500:'Heavy-duty capacity with careful review of mounting, geometry, deflection, and end-use conditions.',
      over500:'Very high load: application engineering review is recommended before a slide or rail platform is selected.',
      unknown:'Define operating load and load distribution before final part selection.',
      custom:'Application-specific load case requires engineering review.'
    };
    Object.assign(loadMap,parseCopy('loadMap'));
    const extMap={
      partial:'Partial-extension travel where complete access is not required.',
      full:'Full-extension access to the moving component.',
      overtravel:'Overtravel beyond full extension where access must extend past the closed envelope.',
      twoway:'Two-way travel evaluated as part of the application design.',
      unsure:'Define stroke / travel during application review.',
      custom:'Application-specific travel or stroke requirement.'
    };
    Object.assign(extMap,parseCopy('extMap'));
    const mountMap={
      side:'Side-mount configuration and side clearance should be reviewed with the supporting structure.',
      bottom:'Bottom / undermount configuration should be reviewed for load path, attachment and available envelope.',
      horizontal:'Horizontal or flat mounting requires configuration-specific review because capacity and deflection can change materially.',
      vertical:'Vertical mounting orientation should be validated for load path, retention and operating behavior.',
      limited:'Compact / low-profile packaging makes clearance, member profile and attachment geometry critical design inputs.',
      custom:'Custom mounting geometry or attachment requirements should be defined with application drawings.',
      unknown:'Mounting orientation and clearance still need to be defined.'
    };
    Object.assign(mountMap,parseCopy('mountMap'));
    const motionMap={
      softclose:'Controlled soft-close behavior near end of travel should be evaluated for closing force, mass and cycle requirements.',
      selfclose:'Self-closing behavior should be evaluated for closing force, moving mass and the intended user interaction.',
      pushopen:'Push-to-open / touch-release actuation should be evaluated with available stroke, preload and user force.',
      loweffort:'Low operating force and smooth travel are intentional user-experience requirements.',
      quiet:'Noise and perceived operating feel should be included in validation criteria.',
      controlled:'Controlled motion through the travel path is an intentional performance requirement.',
      standard:'Straightforward, repeatable opening and closing behavior is the primary motion requirement.'
    };
    Object.assign(motionMap,parseCopy('motionMap'));
    const posMap={
      holdin:'Hold-in / stay-closed positioning is required.',
      holdout:'Hold-out positioning at extension is required.',
      lockin:'Lock-in functionality in the closed position is required.',
      lockout:'Lock-out functionality in the extended position is required.',
      detent:'Detent or a defined positioning point is required.',
      disconnect:'Quick-disconnect or removable-member functionality is required.',
      none:'No special retention or disconnect feature was identified.'
    };
    Object.assign(posMap,parseCopy('posMap'));
    const envMap={
      highcycle:'Durability for frequent cycling and repeated service should be treated as a primary validation input.',
      vibration:'Retention, mounting and positioning should be evaluated for vibration or mobile use.',
      shock:'End stops, retention, mounting and structure should be evaluated for shock / impact exposure.',
      corrosion:'Materials, finishes and lubrication should be evaluated for moisture or corrosion exposure.',
      temperature:'Materials, clearances and lubrication should be evaluated around the specified temperature range.',
      sound:'Operating noise and perceived feel should be included in validation criteria.',
      compact:'Low-profile packaging should preserve usable product space while maintaining structural performance.',
      visible:'Appearance and exposed-finish requirements should be considered in the design.'
    };
    Object.assign(envMap,parseCopy('envMap'));

    function specImplication(type,inputs){
      if(type==='load') return inputs[0]?loadMap[inputs[0].value]:T('Operating load still needs to be defined.');
      if(type==='travel') return inputs[0]?extMap[inputs[0].value]:T('Travel / stroke still needs to be defined.');
      if(type==='mounting') return inputs.map(i=>mountMap[i.value]).filter(Boolean).join(' ');
      if(type==='motion') return inputs.map(i=>motionMap[i.value]).filter(Boolean).join(' ');
      if(type==='positioning') return inputs.map(i=>posMap[i.value]).filter(Boolean).join(' ');
      if(type==='environment') return inputs.map(i=>envMap[i.value]).filter(Boolean).join(' ');
      return '';
    }

    function buildResult(){
      steps.forEach(s=>s.hidden=true);if(!result)return;
      const mkt=marketInput(),app=checked('application')[0],stage=checked('project_stage')[0],volume=checked('volume')[0];
      const load=checked('load')[0],extension=checked('extension')[0],mount=checked('mounting'),motions=checked('motion'),positions=checked('positioning'),envs=checked('environment');
      const envelope=value('envelope'),targetLength=value('target_length'),projectNotes=value('project_notes');
      const design=[],validation=[],terms=[];

      addUnique(design,app?.dataset.note||marketNotes[currentMarket()]);
      if(load)addUnique(design,loadMap[load.value]);
      if(extension)addUnique(design,extMap[extension.value]);
      mount.forEach(i=>addUnique(design,mountMap[i.value]));
      motions.forEach(i=>addUnique(design,motionMap[i.value]));
      positions.forEach(i=>{if(i.value!=='none')addUnique(design,posMap[i.value]);});
      envs.forEach(i=>addUnique(design,envMap[i.value]));
      if(envelope)addUnique(design,T('Packaging review should confirm the stated envelope / clearance: ')+envelope+'.');
      if(targetLength)addUnique(design,T('Confirm slide length and required travel against the stated target: ')+targetLength+'.');

      const rawTerms=(app?.dataset.terms||'').split('|').map(s=>s.trim()).filter(Boolean);
      rawTerms.forEach(t=>addUnique(terms,t));
      if(extension?.value==='full')addUnique(terms,T('full-extension slide / rail'));
      if(extension?.value==='overtravel')addUnique(terms,T('overtravel slide / extension rail'));
      if(load&&['up250','up500','over500'].includes(load.value))addUnique(terms,T('heavy-duty telescopic slide / rail'));
      if(mount.some(i=>i.value==='limited')||envs.some(i=>i.value==='compact'))addUnique(terms,T('low-profile / compact-profile slide'));
      if(positions.some(i=>['lockin','lockout'].includes(i.value)))addUnique(terms,T('locking slide / rail'));
      if(positions.some(i=>i.value==='disconnect'))addUnique(terms,T('quick-disconnect slide'));
      if(envs.some(i=>i.value==='highcycle'))addUnique(terms,T('high-cycle slide / rail'));
      if(envs.some(i=>i.value==='corrosion'))addUnique(terms,T('corrosion-resistant slide / rail'));
      if(envs.some(i=>i.value==='vibration'))addUnique(terms,T('vibration-resistant slide / rail'));
      if(motions.some(i=>i.value==='softclose'))addUnique(terms,T('soft-close slide'));
      if(motions.some(i=>i.value==='pushopen'))addUnique(terms,T('push-to-open slide'));
      if(!terms.length)addUnique(terms,T('application-specific slide / rail solution'));

      addUnique(validation,marketValidation[currentMarket()]);
      if(load)addUnique(validation,T('Confirm load capacity, load distribution and deflection in the intended mounting orientation and supporting structure.'));
      if(extension)addUnique(validation,T('Confirm usable travel, end-stop behavior and access through the complete stroke.'));
      if(envs.some(i=>i.value==='highcycle'))addUnique(validation,T('Define representative cycle-life criteria and test under the intended load and travel conditions.'));
      if(envs.some(i=>i.value==='vibration'||i.value==='shock'))addUnique(validation,T('Include vibration / shock exposure, retention and attachment integrity in application-level validation.'));
      if(envs.some(i=>i.value==='corrosion'))addUnique(validation,T('Review material, finish and corrosion-resistance requirements for the actual exposure condition.'));
      if(envs.some(i=>i.value==='temperature'))addUnique(validation,T('Validate performance across the intended temperature range, including material and lubrication effects.'));
      if(envs.some(i=>i.value==='sound')||motions.some(i=>i.value==='quiet'))addUnique(validation,T('Include operating noise, opening force and perceived motion quality in acceptance criteria.'));
      if(motions.some(i=>i.value==='softclose'||i.value==='selfclose'))addUnique(validation,T('Measure closing force, closing rate and behavior with representative moving mass.'));
      if(positions.some(i=>['holdin','holdout','lockin','lockout','detent'].includes(i.value)))addUnique(validation,T('Validate retention / positioning force and behavior in the intended use condition.'));

      const summary=result.querySelector('[data-kv-selector-summary]');
      if(summary){
        const cards=[
          ['Market',label(mkt)||T('OEM / Other')],['Application',label(app)||T('To be defined')],[T('Program stage'),label(stage)||T('Not specified')],[T('Annual volume'),label(volume)||T('Not specified')],
          [T('Mounting envelope'),envelope||T('Not specified')],[T('Target length / travel'),targetLength||T('Not specified')]
        ];
        if(projectNotes)cards.push([T('Additional requirements'),projectNotes]);
        summary.innerHTML=cards.map((c,idx)=>'<div class="kv-oem-selector__summary-item'+(idx===cards.length-1&&projectNotes?' kv-oem-selector__summary-item--wide':'')+'"><strong>'+esc(c[0])+'</strong><span>'+esc(c[1])+'</span></div>').join('');
      }

      const designBox=result.querySelector('[data-kv-result-design]');
      if(designBox)designBox.innerHTML=design.map(item=>'<div class="kv-oem-selector__design-card"><span class="kv-oem-selector__design-check" aria-hidden="true">✓</span><p>'+esc(item)+'</p></div>').join('');

      const specs=[
        [T('Operating load'),label(load)||T('Not specified'),specImplication('load',load?[load]:[])],
        [T('Travel / extension'),label(extension)||T('Not specified'),specImplication('travel',extension?[extension]:[])],
        [T('Integration / mounting'),joinLabels(mount),specImplication('mounting',mount)||T('Mounting configuration should be confirmed with the product design.')],
        [T('Motion characteristics'),joinLabels(motions),specImplication('motion',motions)||T('Define desired operating feel and actuation behavior.')],
        [T('Retention / positioning'),joinLabels(positions),specImplication('positioning',positions)||T('No special retention requirement was identified.')],
        [T('Operating environment'),joinLabels(envs),specImplication('environment',envs)||T('Define environmental and duty-cycle requirements before final selection.')]
      ];
      if(envelope)specs.push([T('Packaging envelope'),envelope,T('Confirm clearance, attachment geometry and supporting structure against the available envelope.')]);
      if(targetLength)specs.push([T('Length / travel target'),targetLength,T('Confirm slide length, stroke, access and closed-package requirements together.')]);
      const specBox=result.querySelector('[data-kv-result-specs]');
      if(specBox)specBox.innerHTML=specs.map(r=>'<div class="kv-oem-selector__spec-row"><div class="kv-oem-selector__spec-label">'+esc(r[0])+'</div><div class="kv-oem-selector__spec-input">'+esc(r[1])+'</div><div class="kv-oem-selector__spec-implication">'+esc(r[2])+'</div></div>').join('');

      const valBox=result.querySelector('[data-kv-result-validation]');
      if(valBox)valBox.innerHTML=validation.map(v=>'<li><span aria-hidden="true">✓</span><span>'+esc(v)+'</span></li>').join('');

      const openItems=[];
      if(!stage||['unknown','other'].includes(stage.value))addUnique(openItems,T('Confirm the current program stage and target timing.'));
      if(!volume||['unknown','other','na'].includes(volume.value))addUnique(openItems,T('Confirm expected production volume if available.'));
      if(!load||load.value==='unknown')addUnique(openItems,T('Define the operating load and how that load is distributed through the moving assembly.'));
      if(!extension||extension.value==='unsure')addUnique(openItems,T('Confirm required travel / extension and the access needed at full travel.'));
      if(!envelope)addUnique(openItems,T('Confirm available mounting clearance and surrounding product geometry.'));
      if(!targetLength)addUnique(openItems,T('Confirm the target slide length and required travel.'));
      if(!mount.length||mount.some(i=>i.value==='unknown'))addUnique(openItems,T('Confirm mounting orientation, attachment points, and supporting structure.'));
      if(!envs.length)addUnique(openItems,T('Confirm duty cycle and any environmental conditions that should be included in validation.'));
      const openBox=result.querySelector('[data-kv-result-open]');
      const openSection=result.querySelector('[data-kv-open-section]');
      if(openBox){
        const items=openItems.length?openItems:[T('No open requirements were identified by the configurator. KV may request additional detail during engineering review.')];
        openBox.innerHTML=items.map((v,i)=>'<li class="'+(openItems.length?'is-open':'is-complete')+'"><span aria-hidden="true">'+(openItems.length?'!':'✓')+'</span><span>'+esc(v)+'</span></li>').join('');
      }
      if(openSection)openSection.dataset.status=openItems.length?'open':'complete';

      const termBox=result.querySelector('[data-kv-selector-terms]');
      if(termBox)termBox.innerHTML=terms.map(t=>'<span>'+esc(t)+'</span>').join('');

      const plainSpecs=specs.map(r=>r[0]+': '+r[1]+' — '+r[2]);
      lastSpecText=[
        T('KV OEM Slide Configurator — Preliminary Project Specifications'),
        '',
        T('PROJECT OVERVIEW'),
        T('Market: ')+(label(mkt)||T('OEM / Other')),
        T('Application: ')+(label(app)||T('To be defined')),
        T('Program stage: ')+(label(stage)||T('Not specified')),
        T('Annual volume: ')+(label(volume)||T('Not specified')),
        T('Mounting envelope: ')+(envelope||T('Not specified')),
        T('Target length / travel: ')+(targetLength||T('Not specified')),
        projectNotes?T('Additional requirements: ')+projectNotes:'',
        '',
        T('DESIGN CONSIDERATIONS'),
        ...design.map(v=>'• '+v),
        '',
        T('ENGINEERING SPECIFICATIONS'),
        ...plainSpecs.map(v=>'• '+v),
        '',
        T('VALIDATION & PERFORMANCE REVIEW'),
        ...validation.map(v=>'• '+v),
        '',
        T('INFORMATION STILL NEEDED'),
        ...(openItems.length?openItems:[T('No open requirements identified by the configurator.')]).map(v=>'• '+v),
        '',
        T('SLIDE & RAIL DESIGN CHARACTERISTICS TO EVALUATE'),
        ...terms.map(v=>'• '+v),
        '',
        (result.querySelector('.kv-oem-selector__disclaimer')?.textContent||'').trim()
      ].filter(v=>v!==null&&v!==undefined).join('\n');
      if(sharePanel&&!sharePanel.hidden)populateHulk();

      result.hidden=false;
      const resultHeading=result.querySelector('h3');if(resultHeading){resultHeading.tabIndex=-1;resultHeading.focus({preventScroll:true});}
      if(progress)progress.style.width='100%';
      if(progressText)progressText.textContent=T(T('Preliminary project specifications complete'));
      result.scrollIntoView({block:'start',behavior:window.matchMedia(T('(prefers-reduced-motion: reduce)')).matches?'auto':'smooth'});
    }
    filterApplications();
  }

  function initTesting(root){
    if(root.dataset.kvTestingReady==='true') return;
    root.dataset.kvTestingReady='true';
    const items=[...root.querySelectorAll('.kv-oem-testing__item')];
    if(!items.length) return;
    if(root.dataset.openFirst==='true') items[0].open=true;
    if(root.dataset.singleOpen==='true'){
      items.forEach(item=>item.addEventListener('toggle',()=>{if(!item.open)return;items.forEach(other=>{if(other!==item)other.open=false;});}));
    }
  }

  function initAccordion(root){
    if(root.dataset.kvAccordionReady==='true') return;
    root.dataset.kvAccordionReady='true';
    const items=[...root.querySelectorAll('[data-kv-accordion-item]')];
    if(!items.length) return;
    if(root.dataset.openFirst==='true'&&!items.some(item=>item.open)) items[0].open=true;
    if(root.dataset.singleOpen==='true'){
      items.forEach(item=>item.addEventListener('toggle',()=>{
        if(!item.open) return;
        items.forEach(other=>{if(other!==item) other.open=false;});
      }));
    }
    root.querySelectorAll('[data-kv-accordion-trigger]').forEach(trigger=>{
      trigger.addEventListener('click',()=>{
        const index=Number(trigger.dataset.kvStepIndex);
        const item=items[index];
        if(!item) return;
        item.open=true;
        const summary=item.querySelector('summary');
        item.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        if(summary) setTimeout(()=>summary.focus(),180);
      });
    });
  }

  function init(scope){
    (scope||document).querySelectorAll('[data-kv-interactive="tabs"]').forEach(initTabs);
    (scope||document).querySelectorAll('[data-kv-selector]').forEach(initSelector);
    (scope||document).querySelectorAll('[data-kv-testing]').forEach(initTesting);
    (scope||document).querySelectorAll('[data-kv-accordion]').forEach(initAccordion);
    (scope||document).querySelectorAll('[data-kv-gallery]').forEach(initGallery);
  }
  window.KVOEMExperience={init};
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-kv-selector]').forEach(r=>r.kvOemCleanup?.()));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
